import InviteModal from './InviteModal';

export default InviteModal;